import React from "react";
import { Action } from "../../types/LoginType";
import { get } from "../apiRequest";
import { GET_COMPANY_STAFF } from "../apiPath";
import { StaffType } from "../../types/StaffType";

type StaffOverView = {
  staffIdentityId: string;
} & StaffType;

export async function fetchStaffList(dispatch: React.Dispatch<Action>) {
  try {
    const result: StaffType[] = await get(GET_COMPANY_STAFF, {
      param: {
        limit: 1000,
        offset: 0,
      },
    });
    const overViewResult: StaffOverView[] = await get(
      "/Company/StaffOverviews",
      {
        param: {
          limit: 1000,
          offset: 0,
          IsInvitePending: false,
        },
      }
    );

    const staffList = result.map((staff) => {
      const overView = overViewResult.find(
        (o) => o.staffIdentityId === staff.userInfo.id
      );
      return {
        ...staff,
        rbacRoles: overView?.rbacRoles,
        isCompanyOwner: overView?.isCompanyOwner || false,
      };
    });

    dispatch({
      type: "UPDATE_STAFF_LIST",
      staffList,
    });
    return staffList;
  } catch (e) {
    console.error("fetchStaffList", e);
  }
}
